import { render, staticRenderFns } from "./Graphic.vue?vue&type=template&id=2844faef&scoped=true&lang=pug&"
import script from "./Graphic.vue?vue&type=script&lang=js&"
export * from "./Graphic.vue?vue&type=script&lang=js&"
import style0 from "./Graphic.vue?vue&type=style&index=0&id=2844faef&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844faef",
  null
  
)

export default component.exports